import { z } from 'zod';
export {
  customerReviewSchema,
  type CustomerReviewFormValues,
  type NormalizedCustomerReviewValues,
} from './customer-review';

const REVIEW_TEXT_MAX_LENGTH = 1000;
const HIDDEN_NOTE_MAX_LENGTH = 500;

export const merchantReviewResponseSchema = z.object({
  responseText: z
    .string()
    .trim()
    .min(1, { message: 'admin.reviews.response.required' })
    .max(REVIEW_TEXT_MAX_LENGTH, { message: 'admin.reviews.response.tooLong' }),
});

export type MerchantReviewResponseFormValues = z.infer<typeof merchantReviewResponseSchema>;

export const reviewVisibilitySchema = z
  .object({
    visibility: z.enum(['visible', 'hidden']),
    hiddenReason: z
      .enum(['abusive', 'private_info', 'off_topic', 'spam', 'other'])
      .nullable()
      .optional(),
    hiddenNote: z
      .string()
      .trim()
      .max(HIDDEN_NOTE_MAX_LENGTH, { message: 'admin.reviews.visibility.noteTooLong' })
      .nullable()
      .optional(),
  })
  .superRefine((value, ctx) => {
    if (value.visibility === 'hidden' && !value.hiddenReason) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['hiddenReason'],
        message: 'admin.reviews.visibility.reasonRequired',
      });
    }
  })
  .transform((value) => ({
    visibility: value.visibility,
    hiddenReason: value.visibility === 'hidden' ? (value.hiddenReason ?? null) : null,
    hiddenNote: value.visibility === 'hidden' ? value.hiddenNote?.trim() || null : null,
  }));

export type ReviewVisibilityFormValues = z.input<typeof reviewVisibilitySchema>;
export type NormalizedReviewVisibilityValues = z.output<typeof reviewVisibilitySchema>;
